import { WEB_URL } from "@/config/endpoints"
import IMAGES from "@/public/assets/img"


export default {
  SeoContent:{
    title: 'Noticias Credlix',
    url: WEB_URL+'/es-mx/news',
    description:'Listado de Noticias en Credlix',
    keyword: 'financiamiento de cadena de suministro, financiamiento de cadena de suministro en México, cadena de suministro en finanzas, compañía de financiamiento de cadena de suministro', 
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
},
 
    
}